import {
  Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, Inject,
} from '@angular/core';
import { Transition } from '@uirouter/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { shortnameToImage } from 'emojione';

interface EmojiData {
  unicode: string;
  unicode_alternates: string;
  name: string;
  shortname: string;
  category: string;
  emoji_order: string;
  aliases: string[];
  aliases_ascii: string[];
  keywords: string[];
  tone?: string;
}

@Component({
  selector: 'ut-emoji-category',
  templateUrl: './emoji-category.component.html',
  styleUrls: ['./emoji-category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmojiCategoryComponent implements OnInit {
  emojiByCategory: { [key: string]: EmojiData[] } = {};
  tones: string[] = [];
  activeTone: string = '';
  activeCategory: string = 'people';
  categories: string[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    @Inject('$transition$') private $transition$: Transition,
    @Inject('$http') private $http: any,
  ) {}

  ngOnInit(): void {
    // Get category from route params
    this.activeCategory = this.$transition$.params().category || 'people';

    // Load emoji data
    this.$http.get('/utest-static/assets/emoji.json').then((response: any) => {
      this.processEmojiData(response.data);
      this.cdr.markForCheck();
    });
  }

  private processEmojiData(emojiData: { [key: string]: EmojiData }): void {
    // Group emojis by category
    Object.keys(emojiData).forEach((key) => {
      const em = emojiData[key];
      if (!this.emojiByCategory[em.category]) {
        this.emojiByCategory[em.category] = [];
      }
      const toneMatch = em.shortname.match(/:.+(tone[1-5]):/);
      if (toneMatch) {
        em.tone = toneMatch[1];
      }
      this.emojiByCategory[em.category].push(em);
    });

    // Extract tones from modifier category
    if (this.emojiByCategory.modifier) {
      this.tones = this.emojiByCategory.modifier.map(modif => modif.shortname.replace(/:/g, ''));
      this.activeTone = this.tones[0] || '';
      delete this.emojiByCategory.modifier;
    }

    // Get list of categories
    this.categories = Object.keys(this.emojiByCategory);
  }

  setActiveTone(tone: string): void {
    this.activeTone = tone;
    this.cdr.markForCheck();
  }

  toneCheck(em: EmojiData): boolean {
    return !em.tone || em.tone === this.activeTone;
  }

  shortnameToImageHtml(shortname: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(shortnameToImage(shortname));
  }

  getCategoryKeys(): string[] {
    return Object.keys(this.emojiByCategory);
  }
}
